import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _compact from 'lodash/compact';
import { v4 as uuidv4 } from 'uuid';
import { getTypeName } from '../components/Visualizer/utils';
import { DEFAULT_MATRIX } from '../store/design/_initialState';

export const saveDTO = async (design) => {
  const { products = null, designId = null, cart = null, matrix = null } = design;
  if (!products || !designId || !cart || !matrix) {
    return null;
  }
  const { segments } = matrix;

  const transformedSegments = _map(segments, (segment) => {
    const { Start, End } = segment;
    const [startRow, startColumn, startHeight] = Start;
    const [endRow, endColumn, endHeight] = End;

    return {
      Start: {
        Row: startRow,
        Column: startColumn,
        Height: startHeight
      },
      End: {
        Row: endRow,
        Column: endColumn,
        Height: endHeight
      }
    };
  });

  const transformedProducts = _map(products, (product, index) => {
    const {
      Sku, Origin, choiceId, choiceBundle = null
    } = product;
    const [Row, Column, Height] = Origin;
    return {
      Sku,
      Precedence: index,
      Origin: {
        Row,
        Column,
        Height
      },
      ChoiceId: choiceId,
      ChoiceBundle: choiceBundle
        ? { Id: choiceBundle.id, ChoiceId: choiceBundle.choiceId }
        : null
    };
  });

  const dto = await {
    Id: designId,
    Matrix: {
      Rows: matrix?.rows,
      Columns: matrix?.columns,
      Segments: transformedSegments
    },
    Products: transformedProducts,
    Cart: cart
  };

  return dto;
};

export const getDTO = (metadata, designDocument) => {
  const { id, products, cart, matrix } = designDocument;
  const { segments } = matrix || DEFAULT_MATRIX;
  const transformedSegments = _map(segments, (segment) => {
    const { start, end } = segment;
    const { row: startRow, column: startColumn, height: startHeight } = start;
    const { row: endRow, column: endColumn, height: endHeight } = end;

    return {
      Start: [startRow, startColumn, startHeight],
      End: [endRow, endColumn, endHeight]
    };
  });

  const transformedProducts = _map(products, (product) => {
    const {
      sku, origin, precedence, choiceId, choiceBundle
    } = product;
    const { row, column, height } = origin;
    if (!metadata?.[choiceId]) {
      // eslint-disable-next-line no-console
      console.error(`Deactivated choice in design - ${choiceId} - Resetting to empty design`);
      return 'reset';
    }
    return {
      Sku: String(sku),
      precedence,
      Origin: [row, column, height],
      choiceId,
      stackItemId: uuidv4(),
      type: getTypeName(metadata?.[choiceId]),
      choiceBundle: choiceBundle
        ? {
          id: choiceBundle?.id,
          choiceId: choiceBundle?.choiceId,
        }
        : null
    };
  });

  const productsErrorCheck = _filter(transformedProducts, (product) => product === 'reset');

  const transformedBundles = _compact(
    _map(transformedProducts, (product) => {
      const { choiceBundle = null } = product;
      if (choiceBundle) {
        return ({
          bundleId: choiceBundle?.id,
          bundleChoiceId: choiceBundle?.choiceId
        });
      }
      return null;
    }));

  const transformedCart = _map(cart, (lineItem) => {
    const { sku, quantity } = lineItem;
    return {
      Sku: String(sku),
      Quantity: quantity
    };
  });

  return {
    design: {
      designId: id,
      matrix: {
        rows: matrix?.rows,
        columns: matrix?.columns,
        segments: transformedSegments
      },
      products: productsErrorCheck.length ? [] : transformedProducts,
      cart: productsErrorCheck.length ? [] : transformedCart
    },
    bundles: transformedBundles
  };
};
